import React from 'react'
import { Link } from 'react-router-dom';
import useGa from 'hooks/useGa';
import { AttrText } from 'components/AttrText';

export default function WhereToBuy() {
    const gaTracking = useGa();

    return (<>
        <div className="inner-bg"></div>
        <div className="inner-page where-to-buy-page">
            <div className="inner-container">
                <AttrText className="name" text="購買通路">購買通路</AttrText>
                <div className="mgt-6">
                    <div className="logo cha"></div>
                    <div className="tags cha">十六茶 PET530ml</div>
                    <div className="fw-bold d-flex flex-wrap justify-content-center m-auto" style={{maxWidth: "415px"}}>
                        <div>全家、</div>
                        <div>全聯、</div>
                        <div>寶雅、</div>
                        <div>家樂福便利購超市、</div>
                        <div>city'super超市、</div>
                        <div>美廉社、</div>
                        <div>唐吉軻德、</div>
                        <div>家樂福、</div>
                        <div>大潤發、</div>
                        <div>愛買</div>
                    </div>
                    <div className="links">
                        <a
                            href="https://24h.pchome.com.tw/prod/DBAJA8-A900AOI50?fq=/S/DBABI7"
                            target="_blank"
                            className="common-btn green"
                            onClick={() => gaTracking("where-to-buy-16cha-pchome")}
                        >
                            PCHOME
                        </a>
                        <a
                            href="https://www.momoshop.com.tw/goods/GoodsDetail.jsp?i_code=5673727&Area=search&mdiv=403&oid=1_1&cid=index&kw=%E5%8D%81%E5%85%AD%E8%8C%B6"
                            target="_blank"
                            className="common-btn green"
                            onClick={() => gaTracking("where-to-buy-16cha-momo")}
                        >
                            MOMO
                        </a>
                    </div>
                </div>
                <div className="mgt-10">
                    <div className="logo calpis"></div>
                    <div className="tags calpis">「可爾必思」水語 PET500ml</div>
                    <div className="fw-bold d-flex flex-wrap justify-content-center m-auto" style={{maxWidth: "415px"}}>
                        <div>7-11、</div>
                        <div>萊爾富、</div>
                        <div>全聯、</div>
                        <div>美廉社、</div>
                        <div>city'super超市、</div>
                        <div>楓康、</div>
                        <div>寶雅、</div>
                        <div>唐吉軻德、</div>
                        <div>家樂福、</div>
                        <div>大潤發、</div>
                        <div>愛買</div>
                    </div>
                    <div className="tags calpis">「可爾必思」葡萄 PET500ml</div>
                    <div className="fw-bold d-flex flex-wrap justify-content-center m-auto" style={{maxWidth: "415px"}}>
                        <div>全家、</div>
                        <div>全聯、</div>
                        <div>唐吉軻德、</div>
                        <div>楓康、</div>
                        <div>寶雅、</div>
                        <div>city'super超市、</div>
                        <div>JASONS超市</div>
                    </div>
                    <div className="tags calpis">「可爾必思」蔬果 PET500ml</div>
                    <div className="fw-bold d-flex flex-wrap justify-content-center m-auto" style={{maxWidth: "415px"}}>
                        <div>7-11、</div>
                        <div>唐吉軻德、</div>
                        <div>city'super超市、</div>
                        <div>楓康、</div>
                        <div>寶雅</div>
                    </div>
                    <div className="links">
                        <a
                            href="https://24h.pchome.com.tw/store/DBABAV"
                            target="_blank"
                            className="common-btn blue"
                            onClick={() => gaTracking("where-to-buy-calpis-pchome")}
                        >
                            PCHOME
                        </a>
                        <a
                            href="https://www.momoshop.com.tw/category/DgrpCategory.jsp?d_code=2000301165&p_orderType=6&showType=chessboardType"
                            target="_blank"
                            className="common-btn blue"
                            onClick={() => gaTracking("where-to-buy-calpis-momo")}
                        >
                            MOMO
                        </a>
                    </div>
                </div>
                <div className="mgt-8">
                    <Link to="/" className="common-btn yellow" onClick={() => gaTracking("where-to-buy-back-index")}>返回首頁</Link>
                </div>
            </div>
        </div>
    </>)
}